import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Files from './pages/Files';
import ApiKeys from './pages/ApiKeys';
import { AuthProvider } from './contexts/AuthContext';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Authenticator
        socialProviders={['google']}
        signUpAttributes={['email']}
      >
        {({ signOut, user }) => (
          <Router>
            <Layout signOut={signOut} user={user}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/upload" element={<Upload />} />
                <Route path="/files" element={<Files />} />
                <Route path="/apikeys" element={<ApiKeys />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        )}
      </Authenticator>
    </AuthProvider>
  );
};

export default App;
